import React from "react";
import {Row, Col } from 'antd';
import StatusTag from "../statusTag";
import { isNil } from "lodash";

const ApplicationStatusOverview = (props) =>{
    return(
        <Row gutter={32} className="mt-2">
          <Col span={24}>
            <span className="application-id-label">Αριθμός Αίτησης</span>
            <div className="application-id-wrapper">
              <span className="businessKey">{isNil(props.id) ? '-' : props.id}</span>
              <StatusTag status={props.activeTaskName}/>
            </div>
          </Col>
        </Row>
    )
}

export default ApplicationStatusOverview;